import { UserGuard } from '../core/guards/user.guard';
import { Routes } from '@angular/router';
import { RoleAdminGuard } from '../core/guards/role.admin.guard';
import { RoleAdminOrManagerGuard } from '../core/guards/role.admin.manager.guard';
import { GlobalParamsGuard } from '../core/guards/global-params.guard';
import { MerchantHasSetupGuardGuard } from '../core/guards/merchant-has-setup-guard.guard';

export const dashboardRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./dashboard.component').then((m) => m.DashboardComponent),
    canActivate: [UserGuard, GlobalParamsGuard, MerchantHasSetupGuardGuard],
    canActivateChild: [GlobalParamsGuard],
    children: [
      { path: '', redirectTo: 'calendar', pathMatch: 'prefix' },
      {
        path: 'providers',
        pathMatch: 'full',
        canActivate: [RoleAdminOrManagerGuard],
        loadComponent: () => import('./providers-page/providers-page.component').then((m) => m.ProvidersPageComponent),
      },
      {
        path: 'users',
        pathMatch: 'full',
        canActivate: [RoleAdminGuard],
        loadComponent: () => import('./users-page/users-page.component').then((m) => m.UsersPageComponent),
      },
      {
        path: 'services',
        pathMatch: 'full',
        canActivate: [RoleAdminOrManagerGuard],
        loadComponent: () => import('./services-page/services-page.component').then((m) => m.ServicesPageComponent),
      },
      {
        path: 'schedule',
        pathMatch: 'full',
        loadComponent: () => import('./workplan-page/workplan-page.component').then((m) => m.WorkplanPageComponent),
      },
      {
        path: 'workplan-override',
        pathMatch: 'full',
        loadComponent: () => import('./workplan-override/workplan-override.component').then((m) => m.WorkplanOverrideComponent),
      },
      // { path: 'payment', pathMatch: 'full', loadComponent: () => import('./payment/payment.component').then(m => m.PaymentComponent) },
      {
        path: 'calendar',
        pathMatch: 'full',
        loadComponent: () => import('./new-calendar-page/new-calendar-page.component').then((m) => m.NewCalendarPageComponent),
      },
      {
        path: 'welcome',
        pathMatch: 'full',
        loadComponent: () => import('./new-calendar-page/new-calendar-page.component').then((m) => m.NewCalendarPageComponent),
      },
      {
        path: 'calendar/week',
        pathMatch: 'full',
        loadComponent: () =>
          import('./new-calendar-week-page/new-calendar-week-page.component').then((m) => m.NewCalendarWeekPageComponent),
      },
      {
        path: 'clients',
        pathMatch: 'full',
        canActivate: [UserGuard],
        loadComponent: () => import('./clients-page/clients-page.component').then((m) => m.ClientsPageComponent),
        data: { clientType: 'clients' },
      },
      {
        path: 'clients/blacklist',
        pathMatch: 'full',
        canActivate: [UserGuard],
        loadComponent: () => import('./clients-page/clients-page.component').then((m) => m.ClientsPageComponent),
        data: { clientType: 'blacklist' },
      },
      {
        path: 'settings',
        pathMatch: 'full',
        canActivate: [RoleAdminOrManagerGuard],
        loadComponent: () => import('./store-settings-page/store-settings-page.component').then((m) => m.StoreSettingsPageComponent),
      },
      {
        path: 'settings/custom-fields',
        pathMatch: 'full',
        canActivate: [RoleAdminGuard],
        loadComponent: () =>
          import('./setup-custom-fields-page/setup-custom-fields-page.component').then((m) => m.SetupCustomFieldsPageComponent),
      },
      {
        path: 'account',
        pathMatch: 'full',
        canActivate: [],
        loadComponent: () => import('./account-settings-page/account-settings-page.component').then((m) => m.AccountSettingsPageComponent),
      },
      {
        path: 'referral',
        pathMatch: 'full',
        canActivate: [RoleAdminGuard],
        loadComponent: () => import('./referral-page/referral-page.component').then((m) => m.ReferralPageComponent),
      },
      {
        path: 'invoices',
        pathMatch: 'full',
        canActivate: [RoleAdminGuard],
        loadComponent: () => import('./account-invoices-page/account-invoices-page.component').then((m) => m.AccountInvoicesPageComponent),
      },
      {
        path: 'marketing',
        canActivate: [RoleAdminOrManagerGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./marketing-page-v2/marketing-page-v2.component').then((m) => m.MarketingPageV2Component),
          },
          {
            path: 'new-sms-campaign',
            loadComponent: () => import('./sms-campaign-page/sms-campaign-page.component').then((m) => m.SmsCampaignPageComponent),
          },
          {
            path: 'new-email-campaign',
            loadComponent: () => import('./email-campaign-page/email-campaign-page.component').then((m) => m.EmailCampaignPageComponent),
          },
          {
            path: 'campaign/sms/:id',
            loadComponent: () => import('./sms-campaign-page/sms-campaign-page.component').then((m) => m.SmsCampaignPageComponent),
          },
          {
            path: 'campaign/email/:id',
            loadComponent: () => import('./email-campaign-page/email-campaign-page.component').then((m) => m.EmailCampaignPageComponent),
          },
        ],
      },
      {
        path: 'subscription',
        pathMatch: 'full',
        loadComponent: () =>
          import('./store-subscription-page/store-subscription-page.component').then((m) => m.StoreSubscriptionPageComponent),
      },
      // { path: 'discount/code', pathMatch: 'full', loadComponent: () => import('./discount-code-page/discount-code-page.component').then(m => m.DiscountCodePageComponent) },
      {
        path: 'stats',
        pathMatch: 'full',
        loadComponent: () => import('./stats-page/stats-page.component').then((m) => m.StatsPageComponent),
      },
      {
        path: 'extensions',
        pathMatch: 'full',
        loadComponent: () => import('./extensions-page/extensions-page.component').then((m) => m.ExtensionsPageComponent),
      },
      {
        path: 'messaging',
        pathMatch: 'full',
        loadComponent: () => import('./messaging-page/messaging-page.component').then((m) => m.MessagingPageComponent),
      },
      {
        path: 'addons/google',
        pathMatch: 'full',
        loadComponent: () => import('./google-place-setup/google-place-setup.component').then((m) => m.GooglePlaceSetupComponent),
      },
      {
        path: 'extensions/google',
        pathMatch: 'full',
        loadComponent: () => import('./google-place-setup/google-place-setup.component').then((m) => m.GooglePlaceSetupComponent),
      },
      {
        path: 'addons/google-reviews',
        pathMatch: 'full',
        loadComponent: () => import('./google-reviews-setup/google-reviews-setup.component').then((m) => m.GoogleReviewsSetupComponent),
      },
      {
        path: 'extensions/google-reviews',
        pathMatch: 'full',
        loadComponent: () => import('./google-reviews-setup/google-reviews-setup.component').then((m) => m.GoogleReviewsSetupComponent),
      },
      {
        path: 'addons/loyalty',
        pathMatch: 'full',
        loadComponent: () => import('./loyalty-program-page/loyalty-program-page.component').then((m) => m.LoyaltyProgramPageComponent),
      },
      {
        path: 'extensions/loyalty',
        pathMatch: 'full',
        loadComponent: () => import('./loyalty-program-page/loyalty-program-page.component').then((m) => m.LoyaltyProgramPageComponent),
      },
      {
        path: 'addons/rgpd',
        pathMatch: 'full',
        loadComponent: () => import('./rgpd-page/rgpd-page.component').then((m) => m.RgpdPageComponent),
      },
      {
        path: 'extensions/rgpd',
        pathMatch: 'full',
        loadComponent: () => import('./rgpd-page/rgpd-page.component').then((m) => m.RgpdPageComponent),
      },
      {
        path: 'addons/embed',
        pathMatch: 'full',
        loadComponent: () => import('./embed-code-setup/embed-code-setup.component').then((m) => m.EmbedCodeSetupComponent),
      },
      {
        path: 'extensions/embed',
        pathMatch: 'full',
        loadComponent: () => import('./embed-code-setup/embed-code-setup.component').then((m) => m.EmbedCodeSetupComponent),
      },
      {
        path: 'extensions/payments',
        pathMatch: 'full',
        loadComponent: () => import('./payments-setup/payments-setup.component').then((m) => m.PaymentsSetupComponent),
      },
    ],
  },
];
